import React, { useContext, useEffect, useRef, useState } from 'react';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField/TextField';
import Chip from '@mui/material/Chip';
import Container from '@mui/material/Container';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useAddDeviceDetails, useGetColors, useGetModels } from '../../api/hooks/inventory';
import { IconButton, MenuItem } from '@mui/material';
import { ToastContext } from '../../contexts/toast';
import { useQueryClient } from 'react-query';
import { GUARANTEES_PART_INFO_KEY } from '../../api/hooks/cache-keys';
import success from '../../sounds/success.wav';
import useSound from 'use-sound';

export default function SubmitDeviceDetailsForm() {
  const { data: models } = useGetModels();
  const { data: colors } = useGetColors();
  const submitDevices = useAddDeviceDetails();
  const queryClient = useQueryClient();
  const { showToast } = useContext(ToastContext);
  const [playSuccessSound] = useSound(success);

  const [selectedFile, setSelectedFile] = useState(null);
  const [modelId, setModelId] = useState(null);
  const [colorId, setColorId] = useState(null);
  const [imei, setImei] = useState('');

  const formRef = useRef();
  function handleDelete() {
    setSelectedFile(null);
    formRef.current.reset();
  }

  async function sumbitRequest() {
    try {
      await submitDevices.mutateAsync({ modelId, colorId, imei1: imei });
      queryClient.invalidateQueries(GUARANTEES_PART_INFO_KEY());
      showToast('پارت جدید ساخته شد.', 'success');
      setImei('');
      playSuccessSound();
    } catch (e) {
      console.log(e);
      showToast('مشکلی پیش آمده است.', 'error');
    }
  }

  useEffect(() => {
    if (imei.length === 15) {
      sumbitRequest();
    }
  }, [imei]);

  return (
    <Container maxWidth="xs">
      <form ref={formRef}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              select
              fullWidth
              label="مدل"
              size="small"
              onChange={(e) => setModelId(e.target.value)}
            >
              {models?.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {`${item.name} (${item.ram}/${item.memory})`}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={6}>
            <TextField
              select
              fullWidth
              label="رنگ"
              size="small"
              onChange={(e) => setColorId(e.target.value)}
            >
              {colors?.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12}>
            {selectedFile && <Chip label={selectedFile.name} onDelete={handleDelete} />}
          </Grid>

          <Grid item xs={12}>
            <TextField
              size="small"
              label="IMEI 1"
              type="numeral"
              onChange={(e) => setImei(e.target.value)}
              value={imei}
              fullWidth
              InputProps={{
                endAdornment:
                  imei.length > 0 ? (
                    <IconButton onClick={() => setImei('')} sx={{ p: 0 }}>
                      <HighlightOffIcon position="end" />
                    </IconButton>
                  ) : (
                    <QrCodeScannerIcon position="end" />
                  ),
              }}
            />
          </Grid>
        </Grid>
      </form>
    </Container>
  );
}
